const projectInformation = [
    {
        "title": "Natours",
        "about": "This is a server side rendered webpage whose major work include the creation of API which could perform CRUD operations efficiently.Routing to different types of tours via expressJS, user authentication via JWT and payment via stripe while data for each tour, place and user is stored in MongoDB database was all done for the purpose of learning back end and its application.",

        "techUsed": ["NodeJs", "ExpressJS", "MongoDB"],
        "picture": "project-natours",
        "key": 1,
        "linkUsed": "https://github.com/Rishabh-Singh-01/Forkify-Complete"
    },
    {
        "title": "Forkify",
        "about": "This is a vanilla JS project which fetches data about different types of dishes from forkify API and display it using ES6+ javascript and css. This webpage demonstrate displaying different search results, pagination, bookmarking and user can add its own personal recipe, all implemented from scratch without any library or framework.",
        "techUsed": ["JavaScript", "HTML", "CSS"],
        "picture": "project-forkify",
        "key": 2,
        "linkUsed": "https://github.com/Rishabh-Singh-01/Natours-Complete"
    },
    {
        "title": "Omnifood",
        "about": "Omnifood is a beautiful designed landing page made for imaginary company which provides its customer healthy and cost efficient meal which is carefully choosen by highly customized ml model. This webapp is made primarily using HTML5 and CSS3, for the purpose of learning the very basics of web dev and front end.",
        "techUsed": ["HTML5", "CSS3"],
        "picture": "project-omnifood",
        "key": 3,
        "linkUsed": "https://github.com/Rishabh-Singh-01/Omnifood-project"
    },
    {
        "title": "Portfolio Website",
        "about": "This is a simple React website  I made as my portfolio so show case my online presence as well as show some of the relevant skills I own in my front end tool box. This includes my skills , resume , projects and my contact details and major work was done on customizing design using css while routing using  react router and hooks for some small but important details.",
        "techUsed": ["ReactJS", "CSS3"],
        "picture": "project-portfolio",
        "key": 4,
        "linkUsed": "https://portfolio-rish.netlify.app/"
    },
];

export default projectInformation;